var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "insta",
    d: "M12,8.084a6.153,6.153,0,1,0,6.152,6.153A6.143,6.143,0,0,0,12,8.084Zm0,10.154a4,4,0,1,1,4-4,4.007,4.007,0,0,1-4,4ZM19.836,7.833A1.435,1.435,0,1,1,18.4,6.4,1.432,1.432,0,0,1,19.836,7.833ZM23.91,9.289a7.1,7.1,0,0,0-1.938-5.029,7.147,7.147,0,0,0-5.028-1.939c-1.981-.112-7.919-.112-9.9,0A7.137,7.137,0,0,0,2.017,4.255,7.127,7.127,0,0,0,.079,9.284c-.112,1.981-.112,7.921,0,9.9a7.1,7.1,0,0,0,1.938,5.029,7.156,7.156,0,0,0,5.028,1.939c1.981.112,7.919.112,9.9,0a7.1,7.1,0,0,0,5.028-1.939,7.15,7.15,0,0,0,1.938-5.029c.112-1.981.112-7.915,0-9.9ZM21.351,21.312a4.05,4.05,0,0,1-2.281,2.281c-1.579.627-5.327.482-7.073.482s-5.5.139-7.073-.482a4.05,4.05,0,0,1-2.281-2.281c-.626-1.58-.482-5.329-.482-7.074s-.139-5.5.482-7.074A4.05,4.05,0,0,1,4.925,4.882C6.5,4.255,10.252,4.4,12,4.4s5.5-.139,7.073.482a4.05,4.05,0,0,1,2.281,2.281c.626,1.58.482,5.329.482,7.074S21.978,19.738,21.351,21.312Z",
    transform: "translate(0.005 -2.238)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e6002dd3cfe3d53079387de6fe791675.svg";
export { ForwardRef as ReactComponent };